import Footer from 'components/Footer'
import Navigation from 'components/Navigation'
import { TOKEN_KEY_QUERY } from 'config/constants'
import routes from 'config/routes'
import { useBankrolls } from 'hooks'
import PropTypes from 'prop-types'
import React from 'react'
import { Container } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { logout, ssoStart, startup } from './actions'
import { CurrencyContext } from './contexts'
import * as screens from './screens'
import { currencies, sleep } from './utils'

function App({
  authenticated,
  currency,
  ssoStart,
  startup,
  history,
  logout,
  location: { pathname, search },
}) {
  const [loading, setLoading] = React.useState(true)
  const [loggingOut, setLoggingOut] = React.useState(false)
  const { currentBankroll, switchingBankrolls } = useBankrolls()
  const currencyObj = currencies.find(c => c.name === currency)

  React.useEffect(() => {
    const load = async () => {
      // handle sso launch
      const params = new URLSearchParams(search)
      const token = params.get(TOKEN_KEY_QUERY)
      if (token) {
        try {
          await ssoStart(token)
          history.push(routes.dashboard)
        } catch (err) {
          console.error('sso error')
          console.error(err)
          // no-op
        }
      }

      // attempt startup
      try {
        await Promise.all([startup(), sleep(1000)])
      } catch (err) {
        console.error('startup error')
        console.error(err)
        // no-op
      }
      setLoading(false)
    }

    if (loading) {
      load()
    }
  }, [loading, history, search, ssoStart, startup, setLoading])

  const _logout = async () => {
    setLoggingOut(true)
    await logout()
    // redirect back to the member portal on logout
    window.location.href = 'https://members.blackjackapprenticeship.com'
  }

  if (
    loading ||
    loggingOut ||
    switchingBankrolls ||
    (authenticated && !currentBankroll)
  ) {
    return <screens.Loading />
  }

  if (
    !authenticated &&
    pathname !== routes.needsAuth &&
    pathname !== routes.login
  ) {
    return <Redirect to={routes.needsAuth} />
  }

  return (
    <CurrencyContext.Provider value={currencyObj}>
      <Navigation authenticated={authenticated} onLogout={_logout} />
      <Container className="mb-3 mb-md-5 mt-3">
        <Switch>
          <Route exact path={routes.login} component={screens.Login} />
          <Route exact path={routes.needsAuth} component={screens.NeedsAuth} />
          <Route exact path={routes.settings} component={screens.Settings} />
          <Route path={routes.sessions} component={screens.Sessions} />
          <Route path={routes.expenses} component={screens.Expenses} />
          <Route component={screens.Dashboard} />
        </Switch>
      </Container>
      <Footer />
    </CurrencyContext.Provider>
  )
}

App.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  currency: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  ssoStart: PropTypes.func.isRequired,
  startup: PropTypes.func.isRequired,
}

const mapState = state => ({
  authenticated: state.auth.authenticated,
  currency: state.settings.currency,
})

const mapDispatch = {
  logout,
  ssoStart,
  startup,
}

export default withRouter(connect(mapState, mapDispatch)(App))
